/**
 * PD-17463 — a table's Total row is drawn by each column's own render
 * function, the same one its body rows use. To let a report shorten large
 * totals there (under Amounts: Auto, "$40.17M" like the number cards) without
 * every report wiring its own total cells, the table marks while it draws a
 * total cell; a money formatter that shortens an amount records the exact
 * one, and the table shows it on hover. Render functions run synchronously
 * inside the cell, so the mark is only ever seen by that cell's formatting.
 */
let drawingTotal = false;
let exactAmounts: Array<string> = [];

/** True while the table is drawing a Total row cell. */
export function isDrawingTableTotal(): boolean {
	return drawingTotal;
}

/** Called by a formatter that shortened an amount, with the amount in full. */
export function noteExactTotalAmount(exact: string): void {
	if (drawingTotal) {
		exactAmounts.push(exact);
	}
}

/** Draws one Total row cell, returning it with the exact amounts it shortened. */
export function drawTableTotalCell<T>(draw: () => T): { node: T; exact: Array<string> } {
	const previousDrawing = drawingTotal;
	const previousExact = exactAmounts;
	drawingTotal = true;
	exactAmounts = [];
	try {
		const node = draw();
		return { node, exact: exactAmounts };
	} finally {
		drawingTotal = previousDrawing;
		exactAmounts = previousExact;
	}
}
